import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Layout from '../layout/index.vue'

const routes = [
  {
    path: '/',
    redirect: "/index",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "home",
        component: () => import(/* webpackChunkName: "1" */ "@/views/HomeView.vue"),
        meta: {
          title: "首页"
        }
      }, {
        path: "/companyList",
        name: 'companyList',
        component: () => import('@/views/CompanyList.vue'),
        meta: {
          title: '公司列表'
        }
      }, {
        path: "/insuranceList",
        name: 'insuranceList',
        component: () => import('@/views/InsuranceList.vue'),
        meta: {
          title: '保单列表'
        }
      }, {
        path: "/insuranceListTotal",
        name: 'insuranceListTotal',
        component: () => import('@/views/InsuranceListTotal.vue'),
        meta: {
          title: '保单列表-管理员'
        }
      }, {
        path: "/earningsStatistics",
        name: 'earningsStatistics',
        component: () => import('@/views/EarningsStatistics.vue'),
        meta: {
          title: '收益统计'
        }
      }, {
        path: "/earningsStatisticsPartner",
        name: 'earningsStatisticsPartner',
        component: () => import('@/views/EarningsStatisticsPartner.vue'),
        meta: {
          title: '收益统计-合伙人'
        }
      }, {
        path: "/buyInsurance",
        name: 'buyInsurance',
        component: () => import('@/views/BuyInsurance.vue'),
        meta: {
          title: '购买保险'
        }
      }, {
        path: "/partner",
        name: 'partner',
        component: () => import('@/views/Partner.vue'),
        meta: {
          title: '合伙人'
        }
      }, {
        path: "/product",
        name: 'product',
        component: () => import('@/views/Product.vue'),
        meta: {
          title: '产品设置'
        }
      }, {
        path: "/auditInvoice",
        name: 'auditInvoice',
        component: () => import('@/views/AuditInvoice.vue'),
        meta: {
          title: '发票审核'
        }
      }, {
        path: "/modifyPassword",
        name: 'modifyPassword',
        component: () => import('@/views/system/ModifyPassword.vue'),
        meta: {
          title: '修改密码'
        }
      }
    ]
  }, {
    path: '/test',
    name: 'test',
    component: () => import('@/views/PageTest.vue')
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/system/login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
